import React, { FC } from 'react';
import styled from 'styled-components';

import theme from '~/theme';

interface Props {
  icon: JSX.Element;
  name: string;
  onClick: () => void;
  active?: boolean;
}

const MobileMenuNav: FC<Props> = (props) => {
  const { icon, name, onClick, active } = props;
  return (
    <Container className="MobileMenuNav" onClick={onClick} active={active}>
      <icon.type className="MobileMenuNav-Icon" />
      <div>{name}</div>
    </Container>
  );
};

interface UIProps {
  active?: boolean;
}

const Container = styled.div<UIProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  .MobileMenuNav-Icon {
    font-size: 24px;
    color: ${({ active }) => (active ? theme.primaryColor : '#cacaca')};
    margin-bottom: 8px;
  }
`;

export default MobileMenuNav;
